<template>
  <div>
    <data-table :service="JobService"
                :entity="entity"
                :columns="columns"
                :filters="jobFilters"
                :go-to-details-on-row-click="false"
                @on-row-click="onRowClick"
                ref="table">
      <div class="d-flex" slot="client.name" slot-scope="{row}">

        <div class="ml-2 d-flex flex-column">
          <router-link :to="`/contacts/clients/${row.client.uuid}`" class="text-capitalize font-weight-bold">
            {{row.client.name.toLowerCase()}}
          </router-link>
          <div class="text-capitalize">{{row.organisation_name.toLowerCase()}}</div>
        </div>
      </div>

      <template slot="title" slot-scope="{row}">
        <div class="d-flex align-items-center">
          <base-avatar :src="row.client.image" :name="row.client.name"></base-avatar>
          <div class="ml-2 font-weight-bold" data-test="job-list__title">
            {{row.title}}
          </div>
        </div>
      </template>

      <template slot="from" slot-scope="{row}">
        {{$formatDate(row.from, FRIENDLY_DATE_FORMAT)}}
      </template>

      <template slot="till" slot-scope="{row}">
        {{$formatDate(row.till, FRIENDLY_DATE_FORMAT)}}
      </template>

      <template slot="kpis.views" slot-scope="{row}">
        {{get(row, 'kpis.views', 0)}}
      </template>

      <template slot="kpis.apply_start" slot-scope="{row}">
        {{get(row, 'kpis.apply_start', 0)}}
      </template>

      <template slot="kpis.applicants" slot-scope="{row}">
        {{get(row, 'kpis.applicants', 0)}}
      </template>

      <template slot="location_name" slot-scope="{row}">
        {{countryByCode(row.location_name).name || row.location_name}}
      </template>

      <template slot="country_code" slot-scope="{row}">
        {{countryByCode(row.country_code).name || $t('generic.na')}}
      </template>

      <status-badge slot="status" slot-scope="{row}" :status="row.status"/>
    </data-table>
  </div>
</template>
<script>
  import JobService from 'src/services/JobService'
  import entities from 'src/config/entities'
  import get from 'lodash/get'
  import { FRIENDLY_DATE_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'job-board-logs',
    data () {
      return {
        FRIENDLY_DATE_FORMAT,
        JobService,
        entity: entities.JOB
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'title',
            label: this.$t('job.list.columns.title'),
            minWidth: '160px',
            sortable: true
          },
          {
            prop: 'client.name',
            label: this.$t('job.list.columns.client_name'),
            minWidth: '160px',
          },
          {
            prop: 'from',
            label: this.$t('job.list.columns.from'),
            minWidth: '140px'
          },
          {
            prop: 'till',
            label: this.$t('job.list.columns.till'),
            minWidth: '140px',
          },
          {
            prop: 'kpis.views',
            label: this.$t('job.list.columns.views'),
            minWidth: '80px',
            sortable: true
          },
          {
            prop: 'kpis.apply_start',
            label: this.$t('job.list.columns.apply_start'),
            minWidth: '140px',
            sortable: true
          },
          {
            prop: 'kpis.applicants',
            label: this.$t('job.list.columns.applicants'),
            minWidth: '120px',
            sortable: true
          },
          {
            prop: 'location_name',
            label: this.$t('job.list.columns.location'),
            minWidth: '140px'
          },
          {
            prop: 'country_code',
            label: this.$t('job.list.columns.country'),
            minWidth: '140px'
          },
          {
            prop: 'status',
            label: this.$t('job.list.columns.status'),
            minWidth: '90px',
          }
        ]
      },
      jobFilters () {
        return [
          {key: 'with', value: 'client,job_boards'},
          {key: 'match[job_boards_ids]', value: this.$route.params.id}
        ]
      },
      activeCountries () {
        return this.$store.state.config.countries
      }
    },
    methods: {
      get,
      onRowClick (row, event, column) {
        let exceptions = [this.$t('generic.operations'), this.$t('job.list.columns.client_name'), this.$t('job.list.columns.job_board')]
        if (!exceptions.includes(column.label)) {
          this.$refs.table.navigateToDetails(row)
        }
      },
      countryByCode(code) {
        return this.activeCountries.find(c => c.code === code) || { name: null}
      }
    }
  }
</script>
<style>
</style>
